import * as React from 'react';
import classNames from 'clsx';
import Box from "../Box";
import { PressableField } from "../Pressable";
export const InputGroupContext = /*#__PURE__*/React.createContext({});

class InputGroup extends React.Component {
  render() {
    const {
      children,
      className,
      direction,
      disabled,
      invalid,
      size,
      width,
      wrap
    } = this.props;
    const classes = classNames('InputGroup', {
      'InputGroup--direction--horizontal': direction === 'horizontal',
      'InputGroup--direction--vertical': direction === 'vertical'
    }, className, {
      'Is--disabled': disabled
    });
    const renderableChildren = React.Children.toArray(children);
    const firstChild = 0;
    const lastChild = React.Children.count(renderableChildren) - 1;
    const items = React.Children.map(renderableChildren, (child, i) => {
      let alignSelfValue = 'stretch';
      let flexGrowValue = 1;

      if (direction === 'horizontal' && child && // @ts-expect-error - TS2339 - Property 'props' does not exist on type 'ReactChild | ReactFragment | ReactPortal'.
      child.props && // @ts-expect-error - TS2339 - Property 'props' does not exist on type 'ReactChild | ReactFragment | ReactPortal'.
      child.props.width !== 'maximized') {
        alignSelfValue = 'flex-start';
        flexGrowValue = 0;
      }

      let radiusValue = 'none';

      if (direction === 'horizontal' && i === firstChild) {
        radiusValue = 'left';
      } else if (i === firstChild) {
        radiusValue = 'top';
      } else if (direction === 'horizontal' && i === lastChild) {
        radiusValue = 'right';
      } else if (i === lastChild) {
        radiusValue = 'bottom';
      }

      return /*#__PURE__*/React.createElement(Box, {
        className: "InputGroup-item" // @ts-expect-error - TS2339 - Property 'key' does not exist on type 'ReactChild | ReactFragment | ReactPortal'.
        ,
        key: child.key,
        flex: direction === 'horizontal',
        flexBasis: "auto",
        flexGrow: flexGrowValue,
        flexShrink: 1,
        style: {
          alignSelf: alignSelfValue
        }
      }, /*#__PURE__*/React.createElement(InputGroupContext.Provider, {
        value: {
          inputGroupClassName: 'InputGroup-pressable',
          disabled,
          invalid,
          size,
          // @ts-expect-error - TS2322 - Type 'string' is not assignable to type '"none" | "left" | "top" | "bottom" | "right" | undefined'.
          radius: radiusValue,
          width: direction === 'vertical' ? 'maximized' : undefined
        }
      }, child));
    });
    const widthValue = width;
    const directionValue = direction === 'vertical' ? 'column' : 'row';
    return /*#__PURE__*/React.createElement(PressableField, {
      className: classes,
      ghost: true,
      size: size,
      width: widthValue
    }, /*#__PURE__*/React.createElement(Box, {
      className: "InputGroup-container",
      flex: {
        direction: directionValue,
        wrap: wrap ? 'wrap' : 'nowrap'
      }
    }, items));
  }

}

InputGroup.defaultProps = {
  direction: 'vertical',
  wrap: true
};
export default InputGroup;